// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.today-thoughts-container {
    background: #FCCC4D;
    padding: 0.5rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.today-thoughts-content {
    display: flex;
    gap: 1.2rem;
    align-items: center;
    background: #FFFAEB;
    padding: 0.8rem 1.2rem;
    border-radius: 10px;
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);
    /* transition: all 15s ease;  Changed from 0.3s to 15s */
}

.today-thoughts-content:hover {
    transform: translateY(-1px);
    box-shadow: inset 0 1px 4px rgba(0, 0, 0, 0.15);
}

.today-thoughts-chip {
    background: #DC6803;
    color: #fff;
    padding: 0.4rem 0.8rem;
    border-radius: 20px;
    font-weight: 500;
    letter-spacing: 0.5px;
    box-shadow: 0 2px 4px rgba(220, 104, 3, 0.2);
}

.today-thoughts-text {
    color: #B54708;
    font-size: 0.85rem;
    margin: 0;
    flex: 1 1;
    line-height: 1.5;
    font-weight: 400;
    letter-spacing: 0.2px;
    word-break: break-word; /* Prevents overflow */
}

.thoughts-navigation {
    display: flex;
    gap: 0.5rem;
    margin-left: 1rem;
    align-items: center;
}

.nav-dot {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 2px solid #DC6803;
    background-color: transparent;
    color: #DC6803;
    opacity: 0.6;
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 12px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
}

.nav-dot:hover {
    opacity: 0.7;
}

.nav-dot.active {
    opacity: 1;
    transform: scale(1.2);
}

.today-thoughts-text h4 {
    margin: 0;
    transition: all 15s ease;  /* Changed from 0.3s to 15s */
}

.today-thoughts-text h4 span.highlight {
    background-color: rgba(220, 104, 3, 0.1);
    padding: 0 4px;
    border-radius: 4px;
    color: #DC6803;
    font-weight: 600;
    white-space: nowrap;
    margin-right: 10px ;
}

.audio-play-button {
    background: none;
    border: none;
    color: #DC6803;
    cursor: pointer;
    padding: 0 5px;
    /* padding: 0 5px 0 0; */
    margin-right: 5px;
    display: inline-flex;
    align-items: center;
    transition: transform 0.2s ease;
  }
  
.audio-play-button:hover {
transform: scale(1.1);
}

.audio-play-button:focus {
outline: none;
}
.audio-play-button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  
.audio-play-button:disabled {
opacity: 0.5;
cursor: not-allowed;
}
  
.audio-play-button:not(:disabled):hover {
transform: scale(1.1);
}
@media (max-width: 768px) {
.audio-play-button {
    padding: 0 3px 0 0;
    margin-right: 3px;
}
}
@media (max-width: 768px) {
    .today-thoughts-content {
        padding: 0.6rem 1rem;
        gap: 0.8rem;
        flex-direction: column;
    }

    .today-thoughts-text {
        font-size: 0.75rem;
    }

    .nav-dot {
        width: 15px;
        height: 15px;
        font-size: 8px;
    }
}

@media (max-width: 480px) {
    .today-thoughts-container {
        padding: 0.3rem;
    }

    .today-thoughts-content {
        align-items: center;
        padding: 0.5rem 0.8rem;
    }

    .today-thoughts-chip {
        padding: 0.3rem 0.6rem;
        font-size: 0.7rem;
    }

    .today-thoughts-text {
        font-size: 0.7rem;
        line-height: 1.4;
        text-align: center;
    }

    .thoughts-navigation {
        margin-left: 0.5rem;
        gap: 0.3rem;
    }
    
    .nav-dot {
        font-size: 12px;
        padding: 3px 6px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/topNavbar/todayThoughts.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,eAAe;IACf,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,8CAA8C;IAC9C,wDAAwD;AAC5D;;AAEA;IACI,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,SAAO;IACP,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB,EAAE,sBAAsB;AAClD;;AAEA;IACI,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,6BAA6B;IAC7B,cAAc;IACd,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,wBAAwB,GAAG,6BAA6B;AAC5D;;AAEA;IACI,wCAAwC;IACxC,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,wBAAwB;IACxB,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,+BAA+B;EACjC;;AAEF;AACA,qBAAqB;AACrB;;AAEA;AACA,aAAa;AACb;AACA;IACI,YAAY;IACZ,mBAAmB;EACrB;;AAEF;AACA,YAAY;AACZ,mBAAmB;AACnB;;AAEA;AACA,qBAAqB;AACrB;AACA;AACA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;AACA;AACA;IACI;QACI,oBAAoB;QACpB,WAAW;QACX,sBAAsB;IAC1B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;QACtB,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;QACjB,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;QACnB,WAAW;IACf;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;AACJ","sourcesContent":[".today-thoughts-container {\n    background: #FCCC4D;\n    padding: 0.5rem;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.today-thoughts-content {\n    display: flex;\n    gap: 1.2rem;\n    align-items: center;\n    background: #FFFAEB;\n    padding: 0.8rem 1.2rem;\n    border-radius: 10px;\n    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);\n    /* transition: all 15s ease;  Changed from 0.3s to 15s */\n}\n\n.today-thoughts-content:hover {\n    transform: translateY(-1px);\n    box-shadow: inset 0 1px 4px rgba(0, 0, 0, 0.15);\n}\n\n.today-thoughts-chip {\n    background: #DC6803;\n    color: #fff;\n    padding: 0.4rem 0.8rem;\n    border-radius: 20px;\n    font-weight: 500;\n    letter-spacing: 0.5px;\n    box-shadow: 0 2px 4px rgba(220, 104, 3, 0.2);\n}\n\n.today-thoughts-text {\n    color: #B54708;\n    font-size: 0.85rem;\n    margin: 0;\n    flex: 1;\n    line-height: 1.5;\n    font-weight: 400;\n    letter-spacing: 0.2px;\n    word-break: break-word; /* Prevents overflow */\n}\n\n.thoughts-navigation {\n    display: flex;\n    gap: 0.5rem;\n    margin-left: 1rem;\n    align-items: center;\n}\n\n.nav-dot {\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    border: 2px solid #DC6803;\n    background-color: transparent;\n    color: #DC6803;\n    opacity: 0.6;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    font-size: 12px;\n    font-weight: bold;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.nav-dot:hover {\n    opacity: 0.7;\n}\n\n.nav-dot.active {\n    opacity: 1;\n    transform: scale(1.2);\n}\n\n.today-thoughts-text h4 {\n    margin: 0;\n    transition: all 15s ease;  /* Changed from 0.3s to 15s */\n}\n\n.today-thoughts-text h4 span.highlight {\n    background-color: rgba(220, 104, 3, 0.1);\n    padding: 0 4px;\n    border-radius: 4px;\n    color: #DC6803;\n    font-weight: 600;\n    white-space: nowrap;\n    margin-right: 10px ;\n}\n\n.audio-play-button {\n    background: none;\n    border: none;\n    color: #DC6803;\n    cursor: pointer;\n    padding: 0 5px;\n    /* padding: 0 5px 0 0; */\n    margin-right: 5px;\n    display: inline-flex;\n    align-items: center;\n    transition: transform 0.2s ease;\n  }\n  \n.audio-play-button:hover {\ntransform: scale(1.1);\n}\n\n.audio-play-button:focus {\noutline: none;\n}\n.audio-play-button:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n  \n.audio-play-button:disabled {\nopacity: 0.5;\ncursor: not-allowed;\n}\n  \n.audio-play-button:not(:disabled):hover {\ntransform: scale(1.1);\n}\n@media (max-width: 768px) {\n.audio-play-button {\n    padding: 0 3px 0 0;\n    margin-right: 3px;\n}\n}\n@media (max-width: 768px) {\n    .today-thoughts-content {\n        padding: 0.6rem 1rem;\n        gap: 0.8rem;\n        flex-direction: column;\n    }\n\n    .today-thoughts-text {\n        font-size: 0.75rem;\n    }\n\n    .nav-dot {\n        width: 15px;\n        height: 15px;\n        font-size: 8px;\n    }\n}\n\n@media (max-width: 480px) {\n    .today-thoughts-container {\n        padding: 0.3rem;\n    }\n\n    .today-thoughts-content {\n        align-items: center;\n        padding: 0.5rem 0.8rem;\n    }\n\n    .today-thoughts-chip {\n        padding: 0.3rem 0.6rem;\n        font-size: 0.7rem;\n    }\n\n    .today-thoughts-text {\n        font-size: 0.7rem;\n        line-height: 1.4;\n        text-align: center;\n    }\n\n    .thoughts-navigation {\n        margin-left: 0.5rem;\n        gap: 0.3rem;\n    }\n    \n    .nav-dot {\n        font-size: 12px;\n        padding: 3px 6px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
